import React, { useState } from "react";

const LocationPage = () => {
  const [message, setMessage] = useState("");
  const [userPosition, setUserPosition] = useState(null);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      setMessage("Geolocation is not supported by this browser.");
    }
  };

  const showPosition = (position) => {
    setUserPosition(position);
    setTimeout(() => {
      goBackToApp(position);
    }, 1000);
  };

  const showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        setMessage("You need to allow location access to proceed with the RA-Tracker login.");
        break;
      case error.POSITION_UNAVAILABLE:
        setMessage("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        setMessage("The request to get user location timed out.");
        break;
      default:
        setMessage("An unknown error occurred.");
        break;
    }
  };

  const goBackToApp = (position) => {
    const lat = position.coords.latitude;
    const lon = position.coords.longitude;
    window.location.href = `myapp://location-updated?lat=${lat}&lon=${lon}`;
    setTimeout(() => {
      window.close();
    }, 5000);
  };

  return (
    <div style={styles.container}>
      <h1>Allow Location Access</h1>
      <p>Click the button below to share your location and go back to the app.</p>
      <button style={styles.button} onClick={getLocation}>Allow Location</button>
      <p style={{ color: "red" }}>{message}</p>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    background: "linear-gradient(135deg, #00B4DB, #0083B0)",
    color: "#fff",
    textAlign: "center",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  button: {
    backgroundColor: "#28a745",
    border: "none",
    padding: "15px 30px",
    color: "white",
    fontSize: "1.2rem",
    cursor: "pointer",
    borderRadius: "8px",
    transition: "background-color 0.3s",
    width: "20%",
    margin: "0 auto",
  },
};

export default LocationPage;
